import { render, staticRenderFns } from "./PagedTable.vue?vue&type=template&id=686ac0f0"
import script from "./PagedTable.vue?vue&type=script&lang=js"
export * from "./PagedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports